import React from 'react'
import cursorStyle from './styles'
import '../../containers/baseScreen/styles.css'

const Cursor = () => {
  const [cursorX, setCursorX] = React.useState(0)
  const [cursorY, setCursorY] = React.useState(0)
  const navListElement = document.querySelectorAll(
    '.makeStyles-navListElement-10'
  )
  const cursor = document.querySelector('.makeStyles-appCursor-1')
  window.addEventListener('mousemove', (e) => {
    setCursorX(e.pageX)
    setCursorY(e.pageY)
  })

  navListElement.forEach((link) => {
    link.addEventListener('mouseover', () => {
      cursor?.classList.add(classes.linkGlow)
    })
    link.addEventListener('mouseleave', () => {
      cursor?.classList.remove(classes.linkGlow)
    })
  })

  const classes = cursorStyle()
  return (
    <div
      className={classes.appCursor}
      style={{
        left: cursorX + 'px',
        top: cursorY + 'px',
      }}
    ></div>
  )
}
export default Cursor
